import { S as Swiper } from './swiper-core-DtIdGk2i.js';
import { M as Mousewheel } from './mousewheel-VZQgurnP.js';
import { A as A11y } from './a11y-Cqda0b-Q.js';

class PredictiveSearchSuggestions extends HTMLElement {
  swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Mousewheel],
      slidesPerView: 'auto',
      spaceBetween: 24,
      slidesOffsetAfter: -24,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
      },
    });
  }
}

customElements.define('predictive-search-suggestions', PredictiveSearchSuggestions);
